import { render, staticRenderFns } from "./ProductContentQTV.vue?vue&type=template&id=4e327d44&scoped=true&"
import script from "./ProductContentQTV.vue?vue&type=script&lang=js&"
export * from "./ProductContentQTV.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentQTV.vue?vue&type=style&index=0&id=4e327d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e327d44",
  null
  
)

export default component.exports